import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_W8yFM8xcgJn2: {
	id: 'prd_W8yFM2DEV28xcgJn2'
	ident: 'prd_W8yFM8xcgJn2'
	sku: 'simple_premium_12w_23_99_12w_79_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_h31pE2DEV2znxtDgb'
			amount: 79
			amount_usd: 23.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 23.99
			discount: 55.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_KoLZe2DEV2Ddcr9BS'
			amount: 79
			amount_usd: 79
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_W8yFM8xcgJn2, SubscriptionProduct>
const prd_W8yFM8xcgJn2 = { ident: 'prd_W8yFM8xcgJn2' } as typeof _prd_W8yFM8xcgJn2

export default prd_W8yFM8xcgJn2
